<script setup>
import WebUpLoaderTst from './WebUpLoaderTst.vue'
import { ref, onMounted } from 'vue'
import { getUserList } from '@/api/user'
import { useRouter } from 'vue-router'
const router = useRouter()

import useWechatShare from '@/utils/useWechatShare'

import Vconsole from 'vconsole'
new Vconsole()

// 用于判断显示/隐藏模块
const listFlag = ref(true);
const ifnoFlag = ref(false);
const uploadFlag = ref(false);

const num = ref(0);
const title = ref('');
const area = ref([]);
const attachmentpath = ref('');
const loadData = async () => {
  try {
    const userList = await getUserList({ page: 1, pageSize: 10 })
    area.value = userList.data.area;
    attachmentpath.value = userList.data?.attachmentpath;
    console.log('getUserList是：', userList, attachmentpath)
  } catch (err) {
    // 错误已经在拦截器全局提示，这里仅需处理业务侧特殊逻辑
    console.error(err)
  }
}

const { setCustomShare } = useWechatShare()

onMounted(() => {
  
  setCustomShare({
    title: '暑期专属活动福利',
    desc: '邀请好友参与即可领取专属优惠券，限时7天有效',
    link: 'https://www.chengyou.xyz/vue/',
    imgUrl: 'https://www.chengyou.xyz/vue/images/op-bg.png'
  })
  console.log('--分享111--', setCustomShare)

  loadData();
  // 完整的当前页面URL
  console.log('当前页面完整访问路径:', window.location.href)
  // 仅域名+端口的基础路径
  console.log('页面基础路径:', window.location.origin)
  // 当前页面的路由路径（不含域名）
  console.log('当前路由路径:', window.location.pathname)
})

// 点击事件直接拿到传入的key值
const handleGetKey = (clickKey, clickVal) => {
  console.log('当前点击项的key是：', clickKey, clickVal)
  num.value = clickKey;
  title.value = clickVal;

  listFlag.value = false;
  ifnoFlag.value = true;
}

const showHide = (_title) => {
  if (_title == '返回首页') {
    listFlag.value = true;
    ifnoFlag.value = false;
  } else if (_title == '进入表单') {
    uploadFlag.value = true;
    ifnoFlag.value = false;
  } else if (_title == '返回内容') {
    ifnoFlag.value = true;
    uploadFlag.value = false;
  }
}

import { Button as VanButton, Form as VanForm, Field as VanField, CellGroup as VanCellGroup } from 'vant';
const username = ref('');
const password = ref('');
const onSubmit = (values) => {
  console.log('submit', values);
};


// 基础跳转
const goToAbout = () => {
  // 直接传入路径字符串
  // router.push('/about')
  // 也支持对象写法，可搭配传参

  console.log('--123---')
  router.push({ path: '/admin', query: { id: 123 } })
}
</script>

<template>
  <div>
    index
    <img src="https://www.chengyou.xyz/vue/images/op-bg.png"/>
  </div>
  <div v-if="listFlag">
    <p class="area-css" v-for="(val, index) in area" :key="index" @click="handleGetKey(index, val)">
      {{ val }}
    </p>
  </div>
  <div v-if="ifnoFlag">
    <button @click="goToAbout()">admin</button>
    <button @click="showHide('返回首页')">返回</button>
    <button @click="showHide('进入表单')">进入表单</button>
    <p>{{ title }}</p>
  </div>
  <div v-if="uploadFlag">
    <button @click="showHide('返回内容')">返回上一页</button>
    <van-form @submit="onSubmit">
      <van-cell-group inset>
        <van-field v-model="username" name="username" label="用户名" placeholder="用户名"
          :rules="[{ required: true, message: '请填写用户名' }]" />
        <van-field v-model="password" type="password" name="password" label="密码" placeholder="密码"
          :rules="[{ required: true, message: '请填写密码' }]" />
      </van-cell-group>

      <WebUpLoaderTst />

      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
    
  </div>
</template>

<style scoped>
.area-css {
  text-align: center;
}
</style>
